interface StarsProps {
  count?: number;
  className?: string;
}

export default function Stars({ count = 5, className = "text-sm" }: StarsProps) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, index) => (
        <i key={index} className={`ri-star-fill text-amber-400 ${className}`} />
      ))}
    </div>
  );
}